import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderState {
  id: string;
  providerGroupId: string;
  type: string;
  name: string;
  country: string;
  locality: string;
  address: string;
  phone: string;
  email: string;
  bankAccount: string;
  bank: string;
  cnp: string;
  signature: string;
  cui: string;
  registrationNumber: string;
  activityDescription: string;
  leadership: string;
  webAddress: string;
  props: {
    [key: string]: any;
  };
}

const initialState: ProviderState = {
  id: '',
  providerGroupId: '',
  type: 'Persoana Juridica',
  name: '',
  country: '',
  locality: '',
  address: '',
  phone: '',
  email: '',
  bankAccount: '',
  bank: '',
  cnp: '',
  signature: '',
  cui: '',
  registrationNumber: '',
  activityDescription: '',
  leadership: '',
  webAddress: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const providerSlice = createSlice({
  name: 'provider',
  initialState,
  reducers: {
    setProvider: (state, action: PayloadAction<Partial<ProviderState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<ProviderState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: ProviderState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setProvider, updateField, updateProps, resetProps } = providerSlice.actions;

export default providerSlice.reducer;
